"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _tokens = require("../styles/tokens");
var _makeStylesInternal = _interopRequireDefault(require("./../makeStyles/makeStylesInternal"));
var _ToggleButtonGroup = _interopRequireDefault(require("@mui/material/ToggleButtonGroup"));
var _excluded = ["children", "orientation", "value", "exclusive", "size"];
var useStyles = (0, _makeStylesInternal.default)(function () {
  return {
    root: {
      border: _tokens.borderWidthThin + " solid " + _tokens.colorBrandNeutral300,
      padding: _tokens.spacingInset10,
      outline: 'none',
      borderRadius: _tokens.sizingXSmall,
      '&:hover': {
        border: _tokens.borderWidthThin + " solid " + _tokens.colorBrandNeutral400
      }
    },
    groupedHorizontal: {
      outline: 'none',
      borderRadius: _tokens.borderRadiusSmall + " !important",
      '&:not(:first-child)': {
        marginLeft: '2px !important',
        borderLeft: _tokens.borderWidthThin + " solid transparent !important"
      }
    },
    groupedVertical: {
      outline: 'none',
      borderRadius: _tokens.borderRadiusSmall + " !important",
      '&:not(:first-child)': {
        marginTop: _tokens.spacing10 + " !important",
        borderTop: _tokens.borderWidthThin + " solid transparent !important"
      }
    },
    largeBorder: {
      border: _tokens.borderWidthThick + " solid " + _tokens.colorBrandNeutral300,
      '&:hover': {
        border: _tokens.borderWidthThick + " solid " + _tokens.colorBrandNeutral400
      }
    }
  };
});
var ToggleButtonGroup = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var _cn;
  var classes = useStyles();
  var children = props.children,
    orientation = props.orientation,
    value = props.value,
    exclusive = props.exclusive,
    size = props.size,
    rest = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
  // showcase all class overrides
  var classOverrides = {
    groupedHorizontal: classes.groupedHorizontal,
    groupedVertical: classes.groupedVertical,
    root: (0, _classnames.default)(classes.root, (_cn = {}, _cn[classes.largeBorder] = size === 'large', _cn))
  };
  return /*#__PURE__*/_react.default.createElement(_ToggleButtonGroup.default, (0, _extends2.default)({
    ref: ref,
    exclusive: exclusive,
    onChange: props.handleAlignment,
    value: value,
    orientation: orientation,
    size: size,
    classes: classOverrides
  }, rest), children);
});
ToggleButtonGroup.muiName = 'ToggleButtonGroup';
ToggleButtonGroup.displayName = 'ToggleButtonGroup';
ToggleButtonGroup.propTypes = {
  /**
   * Class name to assign the component.
   */
  className: _propTypes.default.string,
  /**
   * Classes used to extend original style object.
   */
  classes: _propTypes.default.object,
  /**
   * The groups of one or more `ToggleButtons`.
   */
  children: _propTypes.default.node.isRequired,
  /**
   * If `true`, only allow one of the child ToggleButton values to be selected.
   */
  exclusive: _propTypes.default.bool,
  /**
   * Callback fired when the value changes.
   *
   * **Signature:**
   * ```
   * function(event: object, value: any) => void
   * ```
   * `event`: The event source of the callback.
   *
   * `value`: of the selected buttons. When `exclusive` is true this is a single value; when false an array of selected values. If no value is selected and `exclusive is true the value is null; when false an empty array.
   */
  onChange: _propTypes.default.func,
  /**
   * The group orientation (layout flow direction).
   */
  orientation: _propTypes.default.oneOf(['horizontal', 'vertical']),
  /**
   * The size of the button.
   */
  size: _propTypes.default.oneOf(['large', 'medium', 'small']),
  /**
   * 	The system prop that allows defining system overrides as well as additional CSS styles
   */
  sx: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object, _propTypes.default.bool])), _propTypes.default.func, _propTypes.default.object]),
  /**
   * The currently selected value within the group or an array of selected values when exclusive is false.
   * The value must have reference equality with the option in order to be selected.
   */
  value: _propTypes.default.any,
  /**
   * @ignore
   */
  handleAlignment: _propTypes.default.func
};
ToggleButtonGroup.defaultProps = {
  size: 'medium',
  orientation: 'horizontal'
};
var _default = exports.default = ToggleButtonGroup;